import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "knowledge-test__number" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["name", "value", "checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: "knowledge-test__question",
    disabled: _ctx.disabled
  }, [
    _createElementVNode("legend", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.index + 1), 1),
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.question.text)) + " ", 1),
        (_ctx.index < 2)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.$t("не влияет на балл")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["knowledge-test__options", { 'knowledge-test__options--short': _ctx.isShort }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.options, (option, optionIndex) => {
        return (_openBlock(), _createElementBlock("label", {
          key: optionIndex,
          class: _normalizeClass(["knowledge-test__option", {
          'knowledge-test__option--selected': _ctx.modelValue === optionIndex,
        }])
        }, [
          _createElementVNode("input", {
            type: "radio",
            name: `knowledge-question-${_ctx.index}`,
            value: optionIndex,
            checked: _ctx.modelValue === optionIndex,
            onChange: ($event: any) => (_ctx.$emit('update:modelValue', optionIndex))
          }, null, 40, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(option)), 1)
        ], 2))
      }), 128))
    ], 2)
  ], 8, _hoisted_1))
}